import { Button } from "@/components";
import { FormInput } from "@/components/Form";
import { cn } from "@/utils";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { MdSearch } from "react-icons/md";
import ChatRooms from "./ChatRooms";
import RoomCreateDrawer from "./RoomCreate/RoomCreateDrawer";

interface Filter {
  search?: string;
  status?: string;
  pic?: number;
  s?: string;
}

interface Props {
  className?: string;
  displayView?: "drawer" | "list";
}

const LeftSection: React.FC<Props> = ({ className, displayView }) => {
  // Filter
  const [filter, setFilter] = useState<Filter>({});

  // Open drawer create new chat room
  const [isOpenCreateDrawer, setIsOpenCreateDrawer] = useState(false);

  // Form controls filter chat rooms
  const { control, watch } = useForm<{
    search?: string;
    status?: { label: string; value: string } | null;
    pic?: { label: string; value: number } | null;
  }>({
    defaultValues: {
      search: "",
      status: null,
      pic: null,
    },
  });

  // Watch any values change to filter list chat rooms
  const search = watch("search");
  const status = watch("status");
  const pic = watch("pic");
  useEffect(() => {
    // Implement filter logic here
    setFilter({
      search,
      status: status?.value,
      pic: pic?.value,
    });
  }, [search, status, pic]);

  // Handle new chat room creation
  const handleNewChat = () => {
    setIsOpenCreateDrawer(true);
  };

  return (
    <div
      className={cn(
        "space-y-4 py-4 h-full overflow-hidden flex flex-col",
        className
      )}
    >
      {/* Drawer create new chat room */}
      {isOpenCreateDrawer && (
        <RoomCreateDrawer
          open={isOpenCreateDrawer}
          setOpen={setIsOpenCreateDrawer}
        />
      )}

      {/* Button create new chat room */}
      <div className="space-y-4 px-4">
        <div className="space-y-1">
          <p className="text-lg text-dark font-bold leading-7">事前相談</p>
          <p className="text-xs text-light_secondary leading-4.5">
            折込チラシや店頭販促POP、SNS素材などを作ったら使用する前にご相談ください。規約や景品表示法に照らして、直す必要があるかどうかを確認します。
          </p>
        </div>
        <Button
          onClick={handleNewChat}
          variant="solid"
          color="primary"
          className="h-12 w-full"
        >
          新規作成
        </Button>

        {/* Search by title */}
        <FormInput
          control={control}
          name="search"
          icon={<MdSearch className="size-6 text-grey-600" />}
          placeholder="タイトルで検索"
          className="!h-10 rounded-lg"
          enableDebounce
        />
      </div>
      <ChatRooms filter={filter} displayView={displayView} />
    </div>
  );
};

export default LeftSection;
